document.addEventListener("vsk:product:changed", function(e){
  var productID = e.detail.productID;
  var variantDetails = JSON.parse(sessionStorage.getItem(getSessionStorageKey(productID)));
  var cardTarget = e.target;
  var cardSlider = $(cardTarget).find(".media--slider");
  var prodURL = variantDetails.onlineStoreUrl ? variantDetails.onlineStoreUrl : `/products/${variantDetails.handle}`;
  var prodImages = variantDetails.images.nodes.map(x => "<a href='" + prodURL + "' class='sa-handle'><img src='" + x.url.split('.jpg')[0] + "_354x442_crop_center.progressive.jpg'></a>").slice(1).join("");
  var cardMain = $(cardTarget).find(".no-slider");
  var mainImage = variantDetails.images.nodes[0].url.split('.jpg')[0] + "_354x442_crop_center.progressive.jpg";
  
  setTimeout(function(){
      $(cardSlider).html(prodImages);
      $(cardMain).find(".sa-handle img").attr({"src": mainImage, "srcset": mainImage, "data-srcset": mainImage});
  },100); 
});

function pdSlider() {

  $("body").on("mouseover", "#product-grid .grid__item .media.no-slider", function(){
    $(this).siblings(".media--slider").not('.slick-initialized').slick({
      dots: false,
      autoplay: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
    });
  })

  $("body").on("mouseleave", "#product-grid .grid__item .media.media--slider", function(){
    if($(this).hasClass('slick-initialized')) {
      $(this).slick('unslick');
    }
  });
}

pdSlider();